import React from "react";
import Select from "react-select";
import { Modal, Button, Form, Alert } from "react-bootstrap";
export default function PlansListModal({
  handleClose,
  show,
  addOrUpdatePlansList,
  errorMessage,
  setNamePlan,
  handleInputChange,
  handleModalHide,
  setBrand,
  namePlan,
  brand,
  brands,
  nameModal,
}) {
  return (
    <Modal show={show} size="lg" onHide={() => handleModalHide()} centered>
      <Modal.Header closeButton>
        <Modal.Title>{nameModal} un plan</Modal.Title>
      </Modal.Header>

      <Form
        onSubmit={(e) => {
          e.preventDefault();
          addOrUpdatePlansList();
        }}
      >
        <Modal.Body>
          <div className="row">
            <Form.Group className="mb-3" controlId="formBasicYear">
              <Form.Label>Nom du plan</Form.Label>
              <Form.Control
                type="text"
                required
                autoFocus
                value={namePlan}
                onChange={(e) => {
                  handleInputChange(e);
                  setNamePlan(e.target.value);
                }}
                placeholder="Nom du plan..."
                name="namePlan"
              />
            </Form.Group>
            {errorMessage && (
              <div className="col-md-12 mb-3 p-1">
                <Alert variant="danger" className="m-0">
                  {errorMessage}
                </Alert>
              </div>
            )}
            <Select
              placeholder="Choisir une marque"
              required
              value={brand}
              name="brand"
              onChange={(e) => {
                handleInputChange(e, "brand");
                setBrand(e);
              }}
              options={brands}
              className="black border-white"
            />
          </div>
        </Modal.Body>
        <Modal.Footer className="is-bottom-right">
          <Button
            variant="secondary"
            onClick={() => {
              handleClose();
            }}
          >
            Annuler
          </Button>
          <Button
            variant="success"
            disabled={brand && namePlan ? false : true}
            type="submit"
          >
            Valider
          </Button>
        </Modal.Footer>
      </Form>
    </Modal>
  );
}
